import { Controller } from '@hotwired/stimulus';
import TomSelect from 'tom-select';

// Free-text tag entry over a select or a comma-delimited text input.
export default class extends Controller {
  static values = { createOnBlur: { type: Boolean, default: false } };

  connect() {
    this.select = new TomSelect(this.element, {
      persist: false,
      create: true,
      createOnBlur: this.createOnBlurValue,
      delimiter: ',',
    });
  }

  disconnect() {
    if (this.select) this.select.destroy();
  }
}
